import { Package, ShoppingCart, XCircle } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface KPICardsProps {
    cartsCount: number;
    requirementsCount: number;
    movementsCount: number;
    onCartsClick?: () => void;
    onRequirementsClick?: () => void;
    onMovementsClick?: () => void;
}

export const KPICards: React.FC<KPICardsProps> = ({
    cartsCount,
    requirementsCount,
    movementsCount,
    onCartsClick,
    onRequirementsClick,
    onMovementsClick,
}) => {
    const { t } = useTranslation('merchandiseV3');

    return (
        <div className="grid grid-cols-3 gap-4">
            {/* KPI 1: Despachos */}
            <button
                onClick={onCartsClick}
                className="bg-background border border-border rounded-lg p-4 hover:border-primary hover:shadow-sm transition-all text-left"
            >
                <div className="flex items-center justify-between mb-2">
                    <span className="text-sm text-muted-foreground">
                        {t('receive.kpi.dispatches', 'Despachos')}
                    </span>
                    <ShoppingCart className="w-4 h-4 text-primary" />
                </div>
                <div className="flex items-baseline gap-1">
                    <span className="text-2xl font-bold text-foreground">{cartsCount}</span>
                </div>
            </button>

            {/* KPI 2: Movimientos */}
            <button
                onClick={onMovementsClick}
                className="bg-background border border-border rounded-lg p-4 hover:border-primary hover:shadow-sm transition-all text-left"
            >
                <div className="flex items-center justify-between mb-2">
                    <span className="text-sm text-muted-foreground">
                        {t('receive.kpi.movements', 'Movimientos')}
                    </span>
                    <Package className="w-4 h-4 text-primary" />
                </div>
                <div className="flex items-baseline gap-1">
                    <span className="text-2xl font-bold text-foreground">{movementsCount}</span>
                </div>
            </button>

            {/* KPI 3: Incumplimientos */}
            <button
                onClick={onRequirementsClick}
                className="bg-background border border-border rounded-lg p-4 hover:border-primary hover:shadow-sm transition-all text-left"
            >
                <div className="flex items-center justify-between mb-2">
                    <span className="text-sm text-muted-foreground">
                        {t('receive.kpi.non_compliance', 'Incumplimientos')}
                    </span>
                    <XCircle className="w-4 h-4 text-red-600 dark:text-red-400" />
                </div>
                <div className="flex items-baseline gap-1">
                    <span className="text-2xl font-bold text-foreground">{requirementsCount}</span>
                </div>
            </button>
        </div>
    );
};

